<script setup lang="ts">
import { useRegisterSW } from 'virtual:pwa-register/vue'

const {
  offlineReady,
  needRefresh,
  updateServiceWorker,
} = useRegisterSW()

async function close() {
  offlineReady.value = false
  needRefresh.value = false
}
</script>

<template>
  <div
    v-if="offlineReady || needRefresh"
    class="pwa-toast fixed max-w-full w-[24rem] top-1/2 rounded border shadow-xl bg-white dark:bg-slate-800 p-2 md:p-4 h-auto flex flex-col items-center justify-center z-10"
    role="alert"
  >
    <div class="m-2 mb-4">
      <span v-if="offlineReady">
        App ready to work offline
      </span>
      <span v-else>
        New content available, click on reload button to update.
      </span>
    </div>
    <div class="flex">
      <button
        v-if="needRefresh"
        class="bg-primary text-white mx-auto rounded py-1 px-2"
        @click="updateServiceWorker()"
      >
        Reload
      </button>
      <button
        v-else
        class="bg-primary text-white mx-auto rounded py-1 px-2"
        @click="close"
      >
        Close
      </button>
    </div>
  </div>
</template>

<style>
.pwa-toast {
  left: calc(50% - 12rem);
}
</style>
